<template>
<div class="view-wrap m-b-3 p-b-3 border-bottom">
	<Heading :level="1" text="Welcome" />
	<p>The Durham Business Growth Programme is an integrated programme to boost productivity and support growth in County Durham businesses. The programme is funded by the UK Shared Prosperity Fund (UKSPF) and the Rural England Prosperity Fund (REPF).</p>
	<p>The Programme is led by Business Durham with UMi and RTC as core delivery partners and it offers the following elements:</p>
	<ul>
		<li>Engagement and relationship management</li>
		<li>Productivity and growth support</li>
		<li>Business grants (capital and revenue)</li>
	</ul>
</div>
<section class="view-wrap three-quarters">
	<div class="title-wrap m-b-2 flex align-center space-between wrap">
		<Heading :level="2" text="Login" />
	</div>
	<p class="m-b-1">
		If you have not yet set a password for your account or your password is not working, please click the 'Forgot your password?' link to reset it.
	</p>
	<UserMessage v-if="error" message-type="error" :message-text="error" />

	<form @submit.prevent="login" novalidate ref="form">
		<form-field-set>
			<template #legend>
				<legend class="sr-only">Please enter your email address and password</legend>
			</template>
			<template #fields>
				<InputField
					name="email"
					ref="email"
					label-text="Email"
					placeholder="me@example.com"
					:value="formData.username"
					@emitFieldData="(val) => formData.username = val"
					input-type="email"
					required-error="Please provide your email address"
					:validation-rules="[rules.validateEmail]" />

				<PasswordField
					name="password"
					ref="password"
					label-text="Password"
					:value="formData.password"
					@emitFieldData="(val) => formData.password = val" />
			</template>
		</form-field-set>

		<Button
			class="primary m-t-3"
			button-type="submit"
			text="Login"
			loading-text="Submitting"
			:is-disabled="formSubmitting"
			:is-loading="formSubmitting" />
	</form>
	<div class="flex space-between m-t-2">
		<router-link to="register">Need an account? Register here.</router-link>
		<router-link to="forgot-password">Forgot your password?</router-link>
	</div>
</section>
</template>

<script>
import { mapActions } from 'vuex';
import { validationRules } from '@/utilities/validationRules';
import { formValidator } from '@/mixins/formValidator';

export default {
	name: 'LoginView',
	mixins: [formValidator],
	data: () => ({
		formSubmitting: false,
		error: '',
		rules: validationRules,
		formData: {
			username: '',
			password: '',
			businessUnit: process.env.VUE_APP_BUSINESS_UNIT
		}
	}),
	head: {
		title: `Login | ${process.env.VUE_APP_FUND_NAME}`,
		meta: [
			{ name: 'description', content: `Login to ${process.env.VUE_APP_FUND_NAME}` }
		]
	},
	methods: {
		login () {
			this.error = false;
			if (this.isValid(this.$refs.form)) {
				this.formSubmitting = true;
				this.checkUserVerified(this.formData.username).then((res) => {
					if (res.status === 200) {
						if (res.data === true) {
							this.loginUser(this.formData).then((res) => {
								if (res === true) {
									this.$router.push({ name: 'Dashboard' });
								}
							}).catch((err) => {
								this.error = err.message;
							}).finally(() => {
								this.formSubmitting = false;
							});
						} else {
							this.$router.push({ name: 'VerificationCheck', params: { checkType: 'login' } });
						}
					} else {
						this.error = 'We are unable to find a user with those details. Please go to the register page to create a new account';
					}
				}).catch((err) => {
					this.error = err.message;
				}).finally(() => {
					this.formSubmitting = false;
				}); ;
			} else {
				this.error = 'Please provide your username and password.';
			};
		},
		...mapActions('auth', ['loginUser', 'checkUserVerified'])
	}
};
</script>
